import Vue from "vue"
import App from "./App.vue"
import router from "./router"
import store from "./store"
import "aos/dist/aos.css"
import AOS from "aos"
import ElementUI from "element-ui"
import "element-ui/lib/theme-chalk/index.css"
import CPagination from "@/components/c-pagination/index.vue"
import VueMasonry from "vue-masonry-css"
import Viewer from "v-viewer"
import { Swiper, SwiperSlide } from "vue-awesome-swiper"
import "swiper/css/swiper.min.css"
Vue.component("swiper", Swiper)
Vue.component("swiper-slide", SwiperSlide)
import "@/style/viewer-diy.css"
import "@/assets/font/font.css"
import "@/style/index.scss"
import "@/assets/css/culture.scss"

Vue.use(Viewer)
Vue.use(VueMasonry)
Vue.component("c-pagination", CPagination)
Vue.use(ElementUI)
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app")

AOS.init({
  duration: 2000,
})
